<template>
    <div class="grid">
    <div class="col-12">
        <Card id="toolbar">
            <template #title>
                <Toolbar>
                    <template #right>
                        <div class="p-card-title" style="margin-top:10px;">
                            <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="downloadPrint()" />
                            <Button v-if="this.$IS_PRINT_DOCUMENT == 'TRUE'" label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="exportToPDF" />
                            <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                        </div>
                    </template>
                </Toolbar>
            </template>
        </Card>
        <div class="surface-0" style="background:white;padding:0;margin:0;">
            <div id="apps" class="center">
                <table class="table"  ref="document" style="font-family:'Times New Roman', Times, serif;font-size:12px;" v-if="dataDocument">
                   <thead>
                         <tr style="text-align:center;height: 60px;">
                            <td>  
                                <span class="title">
                                </span>
                            </td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="2"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="text-align:right;">
                            <td colspan="2">{{ dataDocument.location +", "+ this.$formatDateName(dataDocument.Doc_Date)}}</td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="2"></td>
                        </tr>
                       <tr class="th" style="text-align:center;">
                            <td colspan="2"><p style="font-size:18px"><u>BERITA ACARA ADDENDUM 
                                <span :class="[dataDocument.Percentage_Type == 'Pengurangan' || dataDocument.Percentage_Type == 'Cut Off' ? 'strikethrough1' : 'underline']">PENAMBAHAN</span>
                                <span class="strikethrough1">/</span>
                                <span :class="[dataDocument.Percentage_Type == 'Penambahan' || dataDocument.Percentage_Type == 'Cut Off'? 'strikethrough1' : 'underline']">PENGURANGAN</span>
                                <span class="strikethrough1">/</span>
                                <span :class="[dataDocument.Percentage_Type == 'Penambahan' || dataDocument.Percentage_Type == 'Pengurangan'? 'strikethrough1' : 'underline']">CUT OFF</span> PEKERJAAN 
                                </u>
                                <br/>
                                <span style="font-size:15px;">No. Document: {{dataDocument.Doc_No}}</span></p>
                            </td>
                       </tr>
                     
                        <tr>
                            <!-- <th></th> -->
                            <td colspan="2"><p align="justify" class="p1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dengan ini kami menyatakan berdasarkan kontrak kerja antara {{dataDocument.company + " dan " + dataDocument.contractor}} dengan detail sebagai berikut : </p></td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <table class="widht2">
                                    <tbody>
                                        <tr>
                                            <td style="width:40%;">Kontraktor</td>
                                            <td>: {{dataDocument.contractor}}</td>
                                        </tr>
                                        <tr>
                                            <td>Pekerjaan</td>
                                            <td>: {{dataDocument.Deskripsi_Pekerjaan}}</td>
                                        </tr>
                                        <tr>
                                            <td>No. Kontrak/SPK</td>
                                            <td>: {{dataDocument.No_SPK}}</td>
                                        </tr>
                                        <tr>
                                            <td>No. SPO</td>
                                            <td>: {{dataDocument.No_SPO != null ? dataDocument.No_SPO : "-"}}</td>
                                        </tr>
                                        <tr>
                                            <td>Persentase Aktual Pekerjaan Awal</td>
                                            <td>: {{dataDocument.Initial_Actual_Percentage}} %</td>
                                        </tr>
                                        <tr v-if="dataDocument.Percentage_Type != 'Cut Off'">
                                            <td>Persentase <span :class="{'strikethrough' : dataDocument.Percentage_Type == 'Pengurangan'}">Penambahan</span>
                                                <s>/</s>
                                                <span :class="{'strikethrough' : dataDocument.Percentage_Type == 'Penambahan'}">Pengurangan</span></td>
                                            <td>: {{dataDocument.Deduction_Percentage != null ? dataDocument.Deduction_Percentage : "" }} % </td>
                                        </tr>
                                        <tr v-else-if="dataDocument.Percentage_Type == 'Cut Off'">
                                            <td>Deviasi atas Nilai Kontrak (%) </td>
                                            <td>: {{dataDocument.Cut_Off_Progress != null ? dataDocument.Cut_Off_Progress : "" }} % </td>
                                        </tr>
                                        <tr v-if="!showNewSpoDetail">
                                            <td>Nilai Awal Kontrak</td>
                                            <td>: {{dataDocument.InitialContractValue}}</td>
                                        </tr>
                                        <tr v-if="!showNewSpoDetail">
                                            <td>Nilai
                                                <span :class="{'strikethrough' : dataDocument.Type_Persentase == 'Pengurangan' || dataDocument.Type_Persentase == 'Cut Off'}">Penambahan</span>
                                                <s>/</s>
                                                <span :class="{'strikethrough' : dataDocument.Type_Persentase == 'Penambahan' || dataDocument.Type_Persentase == 'Cut Off'}">Pengurangan</span>
                                                <s>/</s>
                                                <span :class="{'strikethrough' : dataDocument.Type_Persentase == 'Penambahan' || dataDocument.Type_Persentase == 'Pengurangan'}">Cut Off</span>
                                               </td>
                                            <td>: {{dataDocument.PPValue}}</td>
                                        </tr>
                                         <tr v-if="!showNewSpoDetail">
                                            <td>Nilai Aktual Kontrak</td>
                                            <td>: {{dataDocument.ActualContractValue}}</td>
                                        </tr>
                                        <tr v-if="!showNewSpoDetail">
                                            <td style="font-weight:bold;">Nilai Final Kontrak</td>
                                            <td style="font-weight:bold;">: {{dataDocument.FinalContractValue}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                        <tr v-if="showNewSpoDetail" style="height: 15px;">
                            <td colspan="2"></td>
                        </tr>
                        <tr v-if="showNewSpoDetail">
                            <td colspan="2">
                                <p class="widht2">Dengan rincian sebagai berikut,</p>
                            </td>
                        </tr>
                        <tr v-if="showNewSpoDetail">
                            <td colspan="2">
                                <table class="widht2 detail-table">
                                    <thead>
                                        <tr>
                                            <th style="width:40%;"><u>Keterangan</u></th>
                                            <th style="width:35%;"><u>Nilai</u></th>
                                            <th style="width:25%;"><u>Nomor SPO</u></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Nilai Awal Kontrak</td>
                                            <td class="amount">{{formatAmount(dataDocument.Initial_Contract_Amount)}}</td>
                                            <td>{{dataDocument.No_SPO}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" style="font-weight:bold;">Nilai
                                                <span :class="{'strikethrough' : dataDocument.Percentage_Type == 'Pengurangan' || dataDocument.Percentage_Type == 'Cut Off'}">Penambahan</span>
                                                <s>/</s>
                                                <span :class="{'strikethrough' : dataDocument.Percentage_Type == 'Penambahan' || dataDocument.Percentage_Type == 'Cut Off'}">Pengurangan</span>
                                                <s>/</s>
                                                <span :class="{'strikethrough' : dataDocument.Percentage_Type == 'Penambahan' || dataDocument.Percentage_Type == 'Pengurangan'}">Cut Off</span>:
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Pengurangan</td>
                                            <td class="amount">{{formatAmount(deductionAmount)}}</td>
                                            <td>{{dataDocument.No_SPO}}</td>
                                        </tr>
                                        <tr>
                                            <td>Penambahan</td>
                                            <td class="amount">{{formatAmount(additionAmount)}}</td>
                                            <td>SPO Baru</td>
                                        </tr>
                                        <tr>
                                            <td>Nilai Aktual Kontrak</td>
                                            <td class="amount">{{formatAmount(dataDocument.Actual_Contract_Amount)}}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight:bold;">Nilai Final Kontrak</td>
                                            <td class="amount" style="font-weight:bold;">{{formatAmount(dataDocument.Final_Contract_Amount)}}</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr v-if="showNewSpoDetail" style="height: 15px;">
                            <td colspan="2"></td>
                        </tr>
                        <tr v-if="showNewSpoDetail">
                            <td colspan="2">
                                <p class="widht2">Total rincian nilai SPO akhir setelah addendum:</p>
                            </td>
                        </tr>
                        <tr v-if="showNewSpoDetail">
                            <td colspan="2">
                                <table class="widht2">
                                    <tbody>
                                        <tr>
                                            <td style="width:40%;padding-left:20px;">SPO {{dataDocument.No_SPO}}</td>
                                            <td>: {{formatAmount(dataDocument.Contract_Amount_Initial_SPO)}}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left:20px;">SPO Baru</td>
                                            <td>: {{formatAmount(dataDocument.Contract_Amount_New_SPO)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr style="height: 15px;">
                            <td colspan="2"></td>
                        </tr>
                        <tr v-if="dataDocument.Type_Persentase != 'Cut Off'">
                            <td colspan="2">
                                <p align="justify" class="widht1">
                                    Adapun scope pekerjaan <span :class="{'strikethrough' : dataDocument.Percentage_Type == 'Pengurangan'}">Penambahan</span>
                                    <s>/</s>
                                    <span :class="{'strikethrough' : dataDocument.Percentage_Type == 'Penambahan'}">Pengurangan</span>
                                    <span style="color:red;">*</span> <span style="font-weight:bold;">(wajib dirincikan) :</span><br/>
                                    <span v-for="(item, i) in dataDocument.summaryScope" :key="item.Id">
                                        {{ item.Scope  }}<br/>
                                        <!-- (i+1)+". " + -->
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 15px;">
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <p align="justify" class="widht1">Dengan alasan :<br/>

                                    <span v-for="(item) in dataDocument.reasons" :key="item.Id">
                                        {{ item.Reason  }}<br/>
                                        <!-- (i+1)+". " + -->
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 15px;">
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <td colspan="2"><p align="justify" class="p1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Semua detail perubahan di atas sudah mendapat verifikasi kesesuaian dan sudah diketahui oleh semua pihak terkait.</p></td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <p align="justify" class="p1">
                                
                                Demikian Berita Acara ini kami buat dengan sebenar-benarnya. Atas perhatian dan kerjasamanya kami ucapkan terima kasih.</p></td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <p align="justify" class="p1" style="font-size:11px;"> <i>NB: Bobot persentase dapat dilihat pada lampiran Berita acara ini</i> </p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <table class="widht1">
                                    <tbody>
                                        <tr>
                                            <td colspan="2" style="width:35%">
                                                <div style="text-align:center;" v-if="dataDocument.Appr_As1">
                                                    <p>Dibuat Oleh,<br/>
                                                        {{dataDocument.comp1}}
                                                    </p> 
                                                    <div v-if="!dataDocument.Appr_Name1"><br/><br/><br/><br/></div>
                                                    <p class="fontsign" v-if="dataDocument.Appr_Name1">
                                                        {{dataDocument.Appr_Name1}}
                                                    </p>
                                                      <span>{{this.$formatDateTime1(dataDocument.ApprDate1)}}</span>
                                                    <hr>
                                                    <p>
                                                        <!-- <span style="color:red;">**</span> -->
                                                         <span> {{dataDocument.Appr_As1}}</span>
                                                    </p> 
                                                </div>
                                            </td>
                                            <td colspan="2" ></td>
                                            <td colspan="2" style="text-align:center;">
                                                <div v-if="dataDocument.Appr_As2">
                                                    <p>Dibuat Oleh,<br/>{{dataDocument.comp2}}</p>
                                                    <span v-if="!dataDocument.Appr_Name2"><br/><br/><br/><br/></span>
                                                    <p class="fontsign" v-if="dataDocument.Appr_Name2">
                                                        {{dataDocument.Appr_Name2}}
                                                    </p>
                                                      <span>{{this.$formatDateTime1(dataDocument.ApprDate2)}}</span>
                                                    <hr>
                                                    <p>
                                                        <!-- <span style="color:red;">**</span>  -->
                                                        <span> {{dataDocument.Appr_As2}}</span>
                                                    </p> 
                                                </div>
                                            </td>
                                        
                                        </tr>
                                        <tr>
                                            <td colspan="2" style="width:35%">
                                                <br/>
                                                <div style="text-align:center;" v-if="dataDocument.Appr_As3">
                                                    <p>Diterima Oleh,<br/>
                                                        {{dataDocument.comp3}}
                                                    </p> <span v-if="!dataDocument.Appr_Name3"><br/><br/><br/><br/></span>
                                                    <p class="fontsign" v-if="dataDocument.Appr_Name3">
                                                        {{dataDocument.Appr_Name3}}
                                                    </p>
                                                      <span>{{this.$formatDateTime1(dataDocument.ApprDate3)}}</span>
                                                    <hr>
                                                    <p>
                                                        <span>{{dataDocument.Appr_As3}}</span>
                                                    </p> 
                                                </div>

                                            </td>
                                            <td colspan="2" ></td> 
                                            <td colspan="2" style="width:35%">
                                                <br/>
                                                <div style="text-align:center;" v-if="dataDocument.Appr_As4">
                                                    <p>
                                                        Disetujui Oleh,<br/>
                                                        {{dataDocument.comp4}}
                                                    </p> 
                                                    <span v-if="!dataDocument.Appr_Name4"><br/><br/><br/><br/></span>
                                                    <p class="fontsign" v-if="dataDocument.Appr_Name4">
                                                        {{dataDocument.Appr_Name4}}
                                                    </p>
                                                      <span>{{this.$formatDateTime1(dataDocument.ApprDate4)}}</span>
                                                    <hr>
                                                    <p>
                                                        <span> {{dataDocument.Appr_As4}}</span>
                                                    </p> 
                                                </div>
                                            </td>
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" style="margin-top:-20px;" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT|| dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL|| dataDocument.Status == this.$APPROVAL_STATUS.REVISED"/>
                            </td>
                            <td>
                                <VueQrcode :value="valueLink" style="width:85px;float:right;margin-right: -10px;margin-top:-20px;"></VueQrcode>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" v-if="dataDocument.is_aproved">
                                <p style="margin-top:10px;font-size:10px;">
                                    <b>
                                        {{ 
                                           this.signBy(dataDocument)
                                        
                                        }}

                                    </b>
                                </p>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div> 
        </div>
</div>
</div>

</template>

<script>
import html2pdf from 'html2pdf.js'
export default{
data(){
    return {

        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        type :this.$TypeDocument.BA_IK_WITH_SPO,
        compCode : "",
        dataDocument:null,
        imgcontractor : "",
        valueLink :this.$store.getters.getUrlApp + this.$route.fullPath,
        signby :  this.$DOCUMENTFOOTER.APPROVED_GENERATED +" (Document Print by " + this.$store.getters.getFullname + " at " + this.$formatDateTime2(new Date()) + ")"
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; 
        return this.signby;
    },  
    downloadPrint(){
        this.$emit('block-ui');
            var self = this;
                const link = this.valueLink;
                this.$axios.get(this.$API_URL + "AddendumMC/" + "downloadprintAddendum", {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG,
                params : {
                    id : this.$route.query.id,
                    linqr : link,
                    company : this.dataDocument.company,
                    contractor : this.dataDocument.contractor,
                    signby : this.signby,
                }  
                })
                .then((response) => {
                    //const url = window.URL.createObjectURL(new Blob([response.data]));
                    let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];

                    const blob = new Blob([response.data], { type: 'application/pdf' });

                    // Create an object URL from the Blob
                    const url = URL.createObjectURL(blob);
                    // Set the iframe src attribute to the object URL
                    window.open(url, '_blank');
                    self.$emit('unblock-ui');
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    self.$emit('unblock-ui');
                    //self.showAssignModal = false;
                });
    },
    formatRupiah(number) {
        const formatter = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });

        return formatter.format(number);
    },
    formatAmount(value) {
        if (value === null || value === undefined) return "";
        const amount = Number(value);
        const sign = amount < 0 ? "-" : "";
        return sign + this.formatRupiah(Math.abs(amount)) + ",- (Exc. PPN)";
    },
    backToIndex(){
        this.$router.push({ path: "/AddendumMC/Index", query: { activeIndex: 2 } });
    },

    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.ceil(table.scrollHeight / 1123);
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";
            if(i != 0){
                pageNumberDiv.style.top = "calc((100% - 10mm + 30px) * " + (i+1)+ ")";
            }else{
                pageNumberDiv.style.top = "calc((100% - 10mm - 22px) * " + (i+1)+ ")";
            }
            pageNumberDiv.style.right = 0;
            pageNumberDiv.style.height = "12px";
            //pageNumberDiv.style.marginBlockStart = "30px"
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },

    exportToPDF() {
        const filename = this.dataDocument ? `BA_Addendum_${this.dataDocument.Doc_No}.pdf` : 'BA_Addendum.pdf';
        html2pdf(this.$refs.document, {
            margin: [8, 10, 8, 10],
            filename: filename,
            image: { type: 'jpeg', quality: 0.98},
            html2canvas: { 
                scale: 2,
                useCORS: true,
                letterRendering: true
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        })
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "AddendumMC/getDataDocAddendum/" +  this.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.imgcontractor = data.imgcontractor;
                self.$emit('unblock-ui');
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.$emit('unblock-ui');
            });
        },
    },
    computed:{
        showNewSpoDetail() {
            return !!(this.dataDocument && this.dataDocument.New_SPO === true);
        },
        deductionAmount() {
            return this.dataDocument?.total_Amount_BoQ_Deduction ?? 0;
        },
        additionAmount() {
            return this.dataDocument?.total_Amount_BoQ_Addition ?? 0;
        },
    },
    created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.getData();
        },
}
</script>
<style>
@media print {
    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    
    body {
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 0;
        margin: 0;
        width: 100%;
        background: white !important;
     }
     
    .surface-0 {
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    * {
        background: white !important;
    }
    
    #apps {
        background: white !important;
    }
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}

#apps{
    width: 80%;
}
.underline{
    text-decoration: underline;
}
</style>
<style scoped>
@page {
    size: A4 portrait !important;
    margin: 8mm 10mm;
}
@media print {
    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    
    body {
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    #apps{
        width: 100%;
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    .grid {
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    .col-12 {
        padding: 0;
        margin: 0;
        background: white !important;
    }
    
    .surface-0 {
        background: white !important;
        margin: 0;
        padding: 0;
    }
    
    table {
        page-break-inside: auto;
    }
    
    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }
    
    thead {
        display: table-header-group;
    }
    
    tfoot {
        display: table-footer-group;
    }
}
.strikethrough{
    text-decoration: line-through;
}
.strikethrough1{
    text-decoration: line-through underline black;
}
.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}
.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    border-top: 1.5px dotted black;
    padding: 0.3px;
    border-bottom: 1.8px solid black;
    margin : 0 auto;
    width:110px;
}

#toolbar{
    max-height: 90px;
}

.title{
    font-size: 30px;
    color: #8e8158e4;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  .widht2{
    width: 71%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  .detail-table{
    border-collapse: collapse;
    page-break-inside: avoid;
  }
  .detail-table th,
  .detail-table td{
    border: 1px solid black;
    padding: 7px 6px;
    height: 22px;
    vertical-align: middle;
  }
  .detail-table th{
    text-align: center;
    font-weight: bold;
  }
  .detail-table td.amount{
    text-align: center;
    white-space: nowrap;
  }
  .fontsign{
    font-family: 'Monotype Corsiva';
    overflow: hidden;
  }
</style>